'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UICheckbox from 'UIComponents/input/UICheckbox';
import FormattedMessage from 'I18n/components/FormattedMessage';

const RememberMeCheckbox = ({
  onChange,
  checked,
  disabled
}) => {
  return /*#__PURE__*/_jsx(UICheckbox, {
    "data-test-id": "remember-me",
    id: "remember",
    className: "m-bottom-4",
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.form.remember"
    })
  });
};

RememberMeCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};
export default RememberMeCheckbox;